import { Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import {
  HistoryComponent,
  HistoryItem,
  HistoryType,
} from '../../components/history/history.component';

export type HistoryPopOutData = {
  items: readonly HistoryItem[];
  title: string;
  types: readonly HistoryType[];
};

@Component({
  selector: 'vectronic-history-pop-out-dialog',
  templateUrl: './history-pop-out-dialog.component.html',
  styleUrls: ['./history-pop-out-dialog.component.scss'],
  imports: [HistoryComponent],
})
export class HistoryPopOutDialogComponent {
  dialogRef = inject(MatDialogRef<HistoryPopOutDialogComponent>);
  data: HistoryPopOutData = inject(MAT_DIALOG_DATA);
}
